import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

// Enums phải đồng bộ với backend
export enum RedirectMatchType {
    EXACT = 'exact',
    CONTAINS = 'contains',
    STARTS_WITH = 'starts_with',
    ENDS_WITH = 'ends_with',
    REGEX = 'regex',
}

export enum RedirectType {
    M301 = 301,
    M302 = 302,
    M307 = 307,
    M410 = 410,
    M451 = 451,
}

// Entity type
export interface Redirection {
    _id: string;
    source: string;
    matchType: RedirectMatchType;
    destination: string;
    type: RedirectType;
    active: boolean;
    hits: number;
    createdAt?: string;
    updatedAt?: string;
}

// DTOs
export interface CreateRedirectionDto {
    source: string;
    matchType?: RedirectMatchType;
    destination: string;
    type?: RedirectType;
    active?: boolean;
}

export type UpdateRedirectionDto = Partial<CreateRedirectionDto>;

export interface GetPaginationRedirectionDto {
    pageIndex?: number;
    pageSize?: number;
    search?: string;
    type?: RedirectType;
}

const REDIRECTION_ENDPOINTS = {
    INDEX: '/redirections',
    BY_ID: (id: string) => `/redirections/${id}`,
    TOGGLE_ACTIVE: (id: string) => `/redirections/${id}/active`,
};

export const redirectionService = {
    // Lấy danh sách có phân trang
    getPaging(params: GetPaginationRedirectionDto): Promise<ApiResponse<any>> {
        return apiClient.get(REDIRECTION_ENDPOINTS.INDEX + '/', params as any);
    },

    // Tạo chuyển hướng
    create(data: CreateRedirectionDto): Promise<ApiResponse<any>> {
        return apiClient.post(REDIRECTION_ENDPOINTS.INDEX + '/', data as any);
    },

    // Cập nhật
    update(id: string, data: UpdateRedirectionDto): Promise<ApiResponse<any>> {
        return apiClient.put(REDIRECTION_ENDPOINTS.BY_ID(id), data as any);
    },

    // Bật/tắt
    toggleActive(id: string, active: boolean): Promise<ApiResponse<any>> {
        return apiClient.patch(REDIRECTION_ENDPOINTS.TOGGLE_ACTIVE(id), { active } as any);
    },

    // Xóa
    remove(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(REDIRECTION_ENDPOINTS.BY_ID(id));
    },
};


